import { TestCategory } from './CategoryModel';
import { ItemsModel } from './ItemsModel';
import { Test } from './TestModel';

export const TEST_CATEGORIES: TestCategory[] = [
  { id: 1, name: 'Microbiology' },
  { id: 2, name: 'Chemicals' }
];
export const Items: ItemsModel[] = [
  { id: 1, name: 'Water' },
  { id: 2, name: 'Ice' },
  { id: 3, name: 'Food' },
  { id: 4, name: 'Hand swab' },
  { id: 5, name: 'Surface swab' }

];

export const TESTS: Test[] = [
  // Microbiology tests
  { id: 1, name: 'Total Bacterial Count', categoryId: 1 },
  { id: 2, name: 'Total Enterobacteriaceae Count', categoryId: 1 },
  { id: 3, name: 'Total Coliform Count', categoryId: 1 },
  { id: 4, name: 'Total Mold and Yeast', categoryId: 1 },
  { id: 5, name: 'Salmonella spp', categoryId: 1 },
  { id: 6, name: 'E. coli spp', categoryId: 1 },
  { id: 7, name: 'Staphylococci', categoryId: 1 },
  { id: 8, name: 'Streptococci', categoryId: 1 },
  { id: 9, name: 'Listeria spp', categoryId: 1 },
  { id: 10, name: 'Shigella spp', categoryId: 1 },
  { id: 11, name: 'Campylobacter spp', categoryId: 1 },
  { id: 12, name: 'Enterococci', categoryId: 1 },
  { id: 13, name: 'Klebsiella', categoryId: 1 },
  { id: 14, name: 'Legionella', categoryId: 1 },
  { id: 15, name: 'Clostridium perfringens', categoryId: 1 },
  { id: 16, name: 'Pseudomonas', categoryId: 1 },
  { id: 17, name: 'Parasite', categoryId: 1 },
  { id: 18, name: 'Protozoa', categoryId: 1 },

  // Chemical tests
  { id: 19, name: 'Turbidity', categoryId: 2 },
  { id: 20, name: 'Total Solids', categoryId: 2 },
  { id: 21, name: 'Phosphates', categoryId: 2 },
  { id: 22, name: 'Nitrate', categoryId: 2 },
  { id: 23, name: 'Hardness', categoryId: 2 },
  { id: 24, name: 'pH', categoryId: 2 },
  { id: 25, name: 'Chlorine', categoryId: 2 },
  { id: 26, name: 'Ammonia', categoryId: 2 },
  { id: 27, name: 'BOD (Biochemical Oxygen Demand)', categoryId: 2 },
  { id: 28, name: 'COD (Chemical Oxygen Demand)', categoryId: 2 },
  { id: 29, name: 'DO (Dissolved Oxygen)', categoryId: 2 },
  { id: 30, name: 'Alkalinity', categoryId: 2 },
  { id: 31, name: 'Sulfate', categoryId: 2 },
  { id: 32, name: 'Fluoride', categoryId: 2 },
  { id: 33, name: 'Heavy Metals', categoryId: 2 }
];
